//  小组列表
<template>
  <div id="RegistrationReview" v-loading="loading" class="mainDiv">
    <el-row type="flex" justify="start" align="middle">
      <el-col :span="10" style="margin-left: 10px">
        <el-button size="small" type="primary" @click="add">新增</el-button>
        <el-button size="small" type="primary" @click="batch">删除</el-button>
      </el-col>
    </el-row>
    <el-table
      ref="multipleTable"
      :data="tableData"
      border
      style="width: 100%"
      @selection-change="handleSelectionChange"
      size="small"
      :header-cell-style="{ 'background-color': '#e8eff9' }"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column type="id" v-if="false"></el-table-column>
      <el-table-column width="50" label="序号">
        <template slot-scope="scope">{{
          scope.$index + 1 + (pageObj.page - 1) * pageObj.pageSize
        }}</template>
      </el-table-column>
      <el-table-column prop="name" label="小组名称"></el-table-column>
      <el-table-column
        prop="schoolUnit"
        label="办学单位"
        width="150"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column prop="teacherNames" label="指导老师"> </el-table-column>
      <el-table-column prop="studentNames" label="学生"></el-table-column>

      <el-table-column
        prop="type"
        label="类型"
        :formatter="formatterColumn"
      ></el-table-column>

      <el-table-column prop="createName" label="创建者"></el-table-column>
      <el-table-column prop="createDate" label="创建时间">
        <template #default="scope">{{
          scope.row.createDate | datetimeFormat
        }}</template>
      </el-table-column>
      <el-table-column prop="updateDate" label="更新时间">
        <template #default="scope">{{
          scope.row.updateDate | datetimeFormat
        }}</template>
      </el-table-column>
      <el-table-column label="操作" width="280">
        <template #default="scope">
          <span class="operation" @click="read(scope.row)">查看详情</span>
          <span class="operation" @click="edit(scope.row)">编辑</span>
          <span class="operation" @click="delected(scope.row)">删除</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageObj.page"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pageObj.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      background
      :total="total"
    >
    </el-pagination>
  </div>
</template>

<script>
import { confirmMsg } from '@/utils/common'
import * as api from '@/api/group/api'
export default {
  name: 'GroupingList',
  components: {},
  data() {
    return {
      loading: false,
      isShowQuery: false,
      tableData: [],
      // 分页
      pageObj: {
        page: 1,
        pageSize: 20,
        courseId: this.$route.query.courseId,
        infoType: this.$route.query.infoType,
      },
      // 总数
      total: 0,
      // 选中的数组
      selectedList: [],
      isShowDialog: false,
      isShowDialogNotPass: false,
    }
  },
  methods: {
    // 监听状态切换
    handleReviewStatusChange() {
      this.pageObj.page = 1
      this.getList()
    },
    //状态改成文字
    formatterColumn(row, column) {
      switch (row.type) {
        case 0:
          return '在线学习'
          break
        default:
          return '未知'
      }
    },
    // 获取数据
    getList() {
      this.loading = true
      const { page, pageSize, courseId, infoType } = this.pageObj
      console.log('this.pageObj', this.pageObj)

      api
        .getGroupList({ page, pageSize, courseId, infoType, uid: this.getUId })
        .then(({ data }) => {
          //data = data.data
          console.log(data)
          this.total = data.data.total
          console.log(data.code)
          console.log(data.msg)
          console.log(data.data.list)
          console.log(JSON.stringify(data.data.list[0]))
          console.log(data.data.total)
          this.tableData = data.data.list
          this.loading = false
        })
    },

    //删除数据
    deleteList(reqdata) {
      console.log('reqdata--> ' + reqdata)
      api.deletes(reqdata).then((res) => {
        if (res.data.code === 100000) {
          if (res.data.msg === '存在分组已被使用，删除失败') {
            this.$message({ type: 'warning', message: res.data.msg })
          } else {
            this.$message({ type: 'success', message: `已删除！` })
          }
          this.getList()
        } else {
          this.$message({ type: 'warning', message: `删除失败！` })
        }
      })
    },
    //删除个别
    delected(row) {
      confirmMsg('是否删除该条数据？', async () => {
        // const idsArry=[row.id]
        let reqdata = {
          ids: row.id,
          // ids:JSON.stringify([row.id])
        }
        this.deleteList(reqdata)
      })
    },
    //    批量删除
    batch() {
      confirmMsg('是否删除这些数据？', async () => {
        const alldata = this.$refs.multipleTable.selection
        let allId = ''
        for (let i of alldata) {
          allId += i.id + ','
        }
        let reqdata = {
          ids: allId,
        }
        console.log(reqdata)
        if (alldata.length == 0) {
          this.$message({ type: 'error', message: `请勾选` })
        } else {
          this.deleteList(reqdata)
        }
      })
    },

    //新增
    add() {
      const url = 'GroupingEdit'
      this.$router.push({
        name: url,
        query: {
          courseType: this.$route.query.infoType,
          courseId: this.$route.query.courseId,
          name: this.$route.query.name,
          schoolUnit: this.$route.query.schoolUnit,
          studentIds: this.$route.query.studentIds,
          teacherIds: this.$route.query.teacherIds,
        },
      })
    },

    // 编辑
    edit(row) {
      const url = 'EditorialTeam'
      this.$emit('set-active-from-sub', url)
      this.$router.push({
        name: url,
        query: {
          id: row.id,
          name: row.name,
          courseId: this.$route.query.courseId,
          teacherNames: row.teacherNames,
          schoolUnit: row.schoolUnit,
          type: row.type,
          studentNames: row.studentNames,
          teacherIds: row.teacherIds,
          studentIds: row.studentIds,
          courseType: this.$route.query.infoType,
        },
      })
    },
    //查看详情
    read(row) {
      const url = 'ViewDetails'
      var jsonString = JSON.stringify(row)
      console.log('====')
      console.log(jsonString)
      this.$router.push({
        name: url,
        query: { id: row.id, edit_style: '2', jsonString: jsonString },
      })
    },
    // 处理选中事件
    handleSelectionChange(arr) {
      this.selectedList = arr
    },

    // 改变页面接收数据大小
    handleSizeChange(val) {
      this.pageObj.pageSize = val
      this.getList()
    },

    // 改变当前页面
    handleCurrentChange(val) {
      this.pageObj.page = val
      this.getList()
    },

    closeRegistrationReviewEdit(msg) {
      this.isShowDialog = false
      if (msg === 'success') {
        this.getList()
      }
    },
  },
  created() {
    this.getList()
  },
  computed: {
    getUId() {
      return localStorage.getItem('uid') 
    },
  },
}
</script>
<style lang="scss" scoped>
/deep/.el-tabs__item {
  font-size: 12px;
}
/deep/.el-tabs__item {
  padding: 0 10px !important;
}
/deep/.el-pagination.is-background .btn-next,
/deep/.el-pagination.is-background .btn-prev,
/deep/.el-pagination.is-background .el-pager li {
  background-color: #e2e8f4;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #265480;
}
</style>
